var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-text',{staticClass:"app-heading",attrs:{"type":_vm.tagComputed,"size":_vm.sizeComputed,"weight":_vm.weightComputed,"color":_vm.color,"icon":_vm.icon,"icon-style":_vm.iconStyle}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }